import { readUnhandledEnumCase } from 'rpc-client-utils';
import { PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import { MARKETING, SALES } from 'self-service-api/constants/ProductLines';
import { useGetInferenceForPricingRedirectQuery } from '../../__generated__/chirp/com/hubspot/personalization/rpc/RecommendationAppRpc.hooks';
import { NavItemEnum } from '../constants/routing/NavItems';
import { useAppSelector } from '../reducers';
import { currentSuiteApiNamesForProductLevelSelector, productSelector } from '../selectors/ProductsSelectors';
import { isValidPaidProductLevel, isValidProductLine } from '../v2/utils/typeguards';
import { useGlobalLoading } from './loadingHooks';
export const useRecommendedProduct = () => {
  const queryResult = useGetInferenceForPricingRedirectQuery();
  const {
    data,
    loading
  } = queryResult;
  return {
    recommendationResponse: data,
    loading
  };
};
export const useIsRecommendedStarterCustomerPlatform = () => {
  const {
    recommendationResponse
  } = useRecommendedProduct();
  return (recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.hub) === 'CRM_SUITE' && (recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.tier) === STARTER;
};
export const useIsRecommendedSalesHubPro = () => {
  const {
    recommendationResponse
  } = useRecommendedProduct();
  return (recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.hub) === SALES && (recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.tier) === PROFESSIONAL;
};
export const useGetRecommendedApiNames = () => {
  const isAppReady = useGlobalLoading();
  const {
    recommendationResponse,
    loading
  } = useRecommendedProduct();
  const hub = recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.hub;
  const tier = recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.tier;
  return useAppSelector(state => {
    if (!isAppReady || loading) {
      return {
        apiNames: undefined,
        loading: true
      };
    }
    if (hub === 'CRM_SUITE') {
      const suiteApiNames = isValidPaidProductLevel(tier) && currentSuiteApiNamesForProductLevelSelector(state, {
        productLevel: tier
      });
      return {
        apiNames: suiteApiNames,
        loading: false
      };
    } else if (isValidProductLine(hub) && isValidPaidProductLevel(tier)) {
      const product = productSelector(state, {
        productLevel: tier,
        productLine: hub
      });
      const apiName = product && product.apiName;
      const apiNames = apiName ? [apiName] : undefined;
      return {
        apiNames,
        loading: false
      };
    }
    return {
      apiNames: undefined,
      loading: false
    };
  });
};
export const useRecommendedRouting = () => {
  const {
    recommendationResponse,
    loading
  } = useRecommendedProduct();
  const recommendedProductLine = (recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.hub) || MARKETING;
  const recommendedRoute = recommendedProductLine === 'CRM_SUITE' ? NavItemEnum.SUITE : readUnhandledEnumCase(recommendedProductLine).toLowerCase();
  return {
    recommendedRoute,
    loading
  };
};